import { Component } from '@angular/core';

@Component({
  selector: 'landing-getstarted-section',
  templateUrl: './getstarted.component.html',
  styleUrls: ['./getstarted.component.scss'],
})
export class LandingGetStartedSectionComponent {
}
